import { render, staticRenderFns } from "./SelectCursoAll.vue?vue&type=template&id=53766c5d&"
import script from "./SelectCursoAll.vue?vue&type=script&lang=js&"
export * from "./SelectCursoAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports